"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5416],{

/***/ 71206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ Alert; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8773);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64040);


function Alert(props) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
        color: "$warning",
        css: {
            dropShadow: "$sm",
            backgroundColor: "$warningLight",
            borderColor: "$warningBorder"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Body */ .ZP.Body, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                justify: "center",
                align: "center",
                css: {
                    ta: "center"
                },
                children: props.children
            })
        })
    });
}


/***/ }),

/***/ 42281:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ LeaderboardTable; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/loading/index.js + 3 modules
var loading = __webpack_require__(97501);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/text/index.js + 3 modules
var esm_text = __webpack_require__(86979);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/spacer/index.js + 2 modules
var spacer = __webpack_require__(28723);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/row/index.js + 2 modules
var row = __webpack_require__(64040);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/button/index.js + 7 modules
var esm_button = __webpack_require__(27690);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/card/index.js + 3 modules
var card = __webpack_require__(8773);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/col/index.js + 2 modules
var col = __webpack_require__(10154);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/grid/index.js + 4 modules
var grid = __webpack_require__(22553);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/badge/index.js + 3 modules
var badge = __webpack_require__(60189);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/table/index.js + 37 modules
var table = __webpack_require__(40304);
// EXTERNAL MODULE: ./components/Alert.tsx
var Alert = __webpack_require__(71206);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./hooks/useLeaderboardContents.ts
var useLeaderboardContents = __webpack_require__(47855);
// EXTERNAL MODULE: ./lib/ApiRoutes.ts
var ApiRoutes = __webpack_require__(54591);
// EXTERNAL MODULE: ./lib/swr.ts
var swr = __webpack_require__(3718);
// EXTERNAL MODULE: ./node_modules/swr/dist/index.mjs
var dist = __webpack_require__(8100);
;// CONCATENATED MODULE: ./hooks/useLeaderboardUsers.ts



var pollLeaderboardConfig = {
    refreshInterval: 15000
};
function useLeaderboardUsers(leaderboardId) {
    return (0,dist/* default */.ZP)(leaderboardId ? "".concat(ApiRoutes/* ApiRoutes.leaderboards */.M.leaderboards, "/").concat(leaderboardId, "/users") : null, swr/* defaultFetcher */.V, pollLeaderboardConfig);
}

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hot-toast/dist/index.mjs + 1 modules
var react_hot_toast_dist = __webpack_require__(86501);
;// CONCATENATED MODULE: ./components/JoinLeaderboard.tsx










function JoinLeaderboard(param) {
    var leaderboardId = param.leaderboardId;
    var ref = (0,_sliced_to_array/* default */.Z)(react.useState(false), 2), isJoining = ref[0], setJoining = ref[1];
    var ref1 = useLeaderboardUsers(leaderboardId), mutateLeaderboardUsers = ref1.mutate;
    var ref2 = (0,useLeaderboardContents/* useLeaderboardContents */.b)(leaderboardId), mutateLeaderboardContents = ref2.mutate;
    var joinLeaderboard = react.useCallback(function() {
        setJoining(true);
        (0,_async_to_generator/* default */.Z)(function() {
            var result;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            fetch("".concat(ApiRoutes/* ApiRoutes.leaderboards */.M.leaderboards, "/").concat(leaderboardId, "/join"), {
                                method: "POST",
                                headers: {
                                    "Content-Type": "application/json"
                                }
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        if (!result.ok) {
                            react_hot_toast_dist/* default.error */.ZP.error("Failed to join leaderboard: " + result.statusText + ". Please try again.");
                        } else {
                            react_hot_toast_dist/* default.success */.ZP.success("Joined!");
                            mutateLeaderboardUsers();
                            mutateLeaderboardContents();
                        }
                        return [
                            2
                        ];
                }
            });
        })();
        setJoining(false);
    }, [
        leaderboardId,
        mutateLeaderboardContents,
        mutateLeaderboardUsers
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                    b: true,
                    children: "Don't miss out on the fun!"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                justify: "center",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.ZP, {
                    auto: true,
                    onClick: joinLeaderboard,
                    disabled: isJoining,
                    children: isJoining ? /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* default */.ZP, {
                        color: "currentColor",
                        size: "sm"
                    }) : "Join Leaderboard \uD83D\uDE80"
                })
            })
        ]
    });
}

// EXTERNAL MODULE: ./components/leaderboard/LeaderboardsGrid.tsx
var LeaderboardsGrid = __webpack_require__(93871);
// EXTERNAL MODULE: ./components/NextImage.tsx
var NextImage = __webpack_require__(44500);
// EXTERNAL MODULE: ./components/NextLink.tsx
var NextLink = __webpack_require__(45201);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/user/index.js + 3 modules
var esm_user = __webpack_require__(70967);
// EXTERNAL MODULE: ./node_modules/@nextui-org/react/esm/link/index.js + 4 modules
var esm_link = __webpack_require__(7087);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./components/TwitterButton.tsx



function TwitterButton(param) {
    var username = param.username;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_link/* default */.ZP, {
        href: "https://twitter.com/".concat(username),
        target: "_blank",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
            alt: "twitter",
            src: "/icons/twitter.svg",
            width: 16,
            height: 16
        })
    });
}

// EXTERNAL MODULE: ./node_modules/date-fns/esm/format/index.js + 17 modules
var format = __webpack_require__(66761);
// EXTERNAL MODULE: ./node_modules/date-fns/esm/formatDistance/index.js + 6 modules
var formatDistance = __webpack_require__(6939);
// EXTERNAL MODULE: ./hooks/usePublicUser.ts
var usePublicUser = __webpack_require__(15722);
// EXTERNAL MODULE: ./lib/constants.ts
var constants = __webpack_require__(59953);
// EXTERNAL MODULE: ./lib/PageRoutes.ts
var PageRoutes = __webpack_require__(77137);
// EXTERNAL MODULE: ./lib/utils.ts
var utils = __webpack_require__(62461);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var next_auth_react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/react-countdown/dist/index.es.js
var index_es = __webpack_require__(98130);
// EXTERNAL MODULE: ./node_modules/react-in-viewport/dist/es/index.js
var es = __webpack_require__(19231);
;// CONCATENATED MODULE: ./components/LeaderboardTable.tsx





















function LeaderboardTable(param) {
    var leaderboardId = param.leaderboardId, title = param.title, canEdit = param.canEdit, creatorId = param.creatorId, startDate = param.startDate, endDate = param.endDate, theme = param.theme, _isGlobal = param.isGlobal, isGlobal = _isGlobal === void 0 ? true : _isGlobal;
    var ref = (0,useLeaderboardContents/* useLeaderboardContents */.b)(leaderboardId), leaderboardContents = ref.data;
    var paginationRef = react.useRef(null);
    var inViewport = (0,es/* useInViewport */.NM)(paginationRef, {
        rootMargin: "500px 0px"
    }, {
        disconnectOnLeave: false
    }).inViewport;
    var ref1 = (0,_sliced_to_array/* default */.Z)(react.useState(10), 2), perPage = ref1[0], setPerPage = ref1[1];
    var ref2 = (0,next_auth_react.useSession)(), session = ref2.data;
    var ref3 = (0,usePublicUser/* usePublicUser */.x)(creatorId, true), creator = ref3.data;
    var _length;
    var numEntries = (_length = leaderboardContents === null || leaderboardContents === void 0 ? void 0 : leaderboardContents.entries.length) !== null && _length !== void 0 ? _length : 0;
    var ref4 = useLeaderboardUsers(leaderboardId), leaderboardUsers = ref4.data;
    react.useEffect(function() {
        if (inViewport && perPage < numEntries) {
            setPerPage(perPage + 10);
        }
    }, [
        inViewport,
        perPage,
        numEntries
    ]);
    // TODO: add serverside paging
    var visibleScoreboardEntries = react.useMemo(function() {
        return leaderboardContents === null || leaderboardContents === void 0 ? void 0 : leaderboardContents.entries.slice(0, perPage);
    }, [
        perPage,
        leaderboardContents === null || leaderboardContents === void 0 ? void 0 : leaderboardContents.entries
    ]);
    if (!leaderboardContents || !visibleScoreboardEntries) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(loading/* default */.ZP, {
            color: "currentColor",
            size: "lg"
        });
    }
    var hasStarted = !startDate || startDate.getTime() < Date.now();
    var hasEnded = endDate && endDate.getTime() < Date.now();
    var showTitle = !theme; // TODO: make this a leaderboard setting
    var _name, _avatarURL;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            showTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                h2: true,
                children: title
            }),
            theme && /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                src: "/leaderboards/".concat(theme.toLowerCase(), "/logo.png"),
                width: 300,
                height: 200,
                objectFit: "contain"
            }),
            creator && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    startDate && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm_text/* default */.Z, {
                            size: "small",
                            color: "$gray700",
                            children: [
                                (0,format/* default */.Z)(new Date(startDate), "d MMMM yyyy"),
                                " -",
                                " ",
                                endDate ? (0,format/* default */.Z)(new Date(endDate), "d MMMM yyyy") : "∞"
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        justify: "center",
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                children: "Created by"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                                x: 0.25
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardUser, {
                                user: {
                                    userId: creator.id,
                                    name: (_name = creator.name) !== null && _name !== void 0 ? _name : undefined,
                                    avatarURL: (_avatarURL = creator.avatarURL) !== null && _avatarURL !== void 0 ? _avatarURL : undefined,
                                    fallbackAvatarId: creator.fallbackAvatarId
                                },
                                theme: theme
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {})
                ]
            }),
            hasEnded && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Alert/* Alert */.b, {
                        children: [
                            "This leaderboard ended",
                            " ",
                            (0,formatDistance/* default */.Z)(new Date(), new Date(endDate)),
                            " ago"
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
            leaderboardId && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                        justify: "center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLink */.p, {
                                href: PageRoutes/* PageRoutes.leaderboard */.d.leaderboard,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.ZP, {
                                        color: "secondary",
                                        children: "Back to global leaderboard"
                                    })
                                })
                            }),
                            canEdit && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLink */.p, {
                                        href: "".concat(PageRoutes/* PageRoutes.leaderboards */.d.leaderboards, "/").concat(leaderboardId, "/edit"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_button/* default */.ZP, {
                                                auto: true,
                                                color: "secondary",
                                                children: "Edit"
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {})
                ]
            }),
            session && !hasEnded && leaderboardId && leaderboardUsers && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
                            css: {
                                height: "130px",
                                justifyContent: "center"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Body */.ZP.Body, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                h3: true,
                                                children: leaderboardUsers.length
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                children: "participants"
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    }),
                    !isGlobal && !leaderboardUsers.some(function(user) {
                        return user.userId === session.user.id;
                    }) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
                                    css: {
                                        height: "130px",
                                        justifyContent: "center"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Body */.ZP.Body, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(row/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(JoinLeaderboard, {
                                                    leaderboardId: leaderboardId
                                                })
                                            })
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {})
                ]
            }),
            hasStarted && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(grid/* default.Container */.ZP.Container, {
                        gap: 1,
                        css: {
                            width: "100%",
                            margin: 0,
                            padding: 0
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
                                xs: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
                                    css: {
                                        dropShadow: "$xs"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Header */.ZP.Header, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                    size: 12,
                                                    weight: "bold",
                                                    transform: "uppercase",
                                                    children: "# Total tips sent"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                    h3: true,
                                                    children: leaderboardContents.numTipsSent
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
                                xs: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
                                    css: {
                                        dropShadow: "$xs"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Header */.ZP.Header, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                    size: 12,
                                                    weight: "bold",
                                                    transform: "uppercase",
                                                    children: "# \uD83C\uDF4A\uD83D\uDC8A people"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                    h3: true,
                                                    children: leaderboardContents.numUsersOnboarded
                                                })
                                            ]
                                        })
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
                                xs: 4,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
                                    css: {
                                        dropShadow: "$xs"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Header */.ZP.Header, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(col/* default */.Z, {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                    size: 12,
                                                    weight: "bold",
                                                    children: "TOTAL TIP VALUE (sats)"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                                                    h3: true,
                                                    css: {
                                                        whiteSpace: "nowrap"
                                                    },
                                                    children: (0,utils/* formatAmount */.dN)(leaderboardContents.totalSatsSent, 1)
                                                })
                                            ]
                                        })
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {})
                ]
            }),
            !leaderboardId && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardsGrid/* LeaderboardsGrid */.j, {
                featured: true
            }),
            session && !leaderboardId && /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardsGrid/* LeaderboardsGrid */.j, {
                userId: session.user.id
            }),
            hasStarted ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: leaderboardContents.entries.length ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardTableContents, {
                            visibleScoreboardEntries: visibleScoreboardEntries,
                            theme: theme
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            ref: paginationRef
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                        blockquote: true,
                        children: "This leaderboard is empty. Send a successful tip to appear here."
                    })
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                        y: 2
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                        h4: true,
                        children: "STARTS IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_text/* default */.Z, {
                        h1: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.ZP, {
                            date: startDate
                        })
                    })
                ]
            })
        ]
    });
}
function LeaderboardTableContents(param) {
    var visibleScoreboardEntries = param.visibleScoreboardEntries, theme = param.theme;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.ZP.Container, {
                gap: 1,
                justify: "center",
                xs: 12,
                sm: 0,
                css: {
                    padding: 0
                },
                children: visibleScoreboardEntries.map(function(scoreboardEntry, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default */.ZP, {
                            css: {
                                dropShadow: "$sm"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card/* default.Body */.ZP.Body, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                    align: "center",
                                    justify: "space-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.ZP, {
                                            css: {
                                                background: i === 0 ? "$gold" : i === 1 ? "$silver" : i === 2 ? "$bronze" : "$gray700"
                                            },
                                            children: i + 1
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardUser, {
                                                theme: theme,
                                                user: scoreboardEntry
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            children: scoreboardEntry.twitterUsername && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterButton, {
                                                username: scoreboardEntry.twitterUsername
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(col/* default */.Z, {
                                            css: {
                                                textAlign: "right"
                                            },
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(badge/* default */.ZP, {
                                                        variant: "flat",
                                                        color: "primary",
                                                        children: [
                                                            (0,utils/* formatAmount */.dN)(scoreboardEntry.satsSent),
                                                            "⚡"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {
                                                        x: 0.5
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(badge/* default */.ZP, {
                                                        variant: "flat",
                                                        color: "primary",
                                                        children: [
                                                            scoreboardEntry.achievementTypes.length,
                                                            "\uD83C\uDFC6"
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            })
                        })
                    }, i);
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(spacer/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default.Container */.ZP.Container, {
                xs: 0,
                sm: 12,
                css: {
                    padding: 0,
                    width: "100%",
                    fg: 1
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(grid/* default */.ZP, {
                    css: {
                        width: "100%"
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* default */.ZP, {
                        fixed: true,
                        css: {
                            zIndex: 10,
                            height: "auto",
                            minWidth: "100%"
                        },
                        containerCss: {
                            background: "$white",
                            dropShadow: "none"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* default.Header */.ZP.Header, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Column */.ZP.Column, {
                                        width: 1,
                                        align: "center",
                                        children: "#"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Column */.ZP.Column, {
                                        css: {
                                            pl: 20
                                        },
                                        children: "Tipper"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Column */.ZP.Column, {
                                        css: {
                                            textAlign: "center"
                                        },
                                        children: "Tips sent"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Column */.ZP.Column, {
                                        css: {
                                            textAlign: "center"
                                        },
                                        children: "Success rate"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Column */.ZP.Column, {
                                        css: {
                                            textAlign: "center"
                                        },
                                        children: "Tipped sats"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Column */.ZP.Column, {
                                        css: {
                                            textAlign: "center"
                                        },
                                        children: "Achievements"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Body */.ZP.Body, {
                                children: visibleScoreboardEntries.map(function(scoreboardEntry, i) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* default.Row */.ZP.Row, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Cell */.ZP.Cell, {
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.ZP, {
                                                    css: {
                                                        background: i === 0 ? "$gold" : i === 1 ? "$silver" : i === 2 ? "$bronze" : "$gray700"
                                                    },
                                                    children: i + 1
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Cell */.ZP.Cell, {
                                                css: {
                                                    overflow: "visible"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(row/* default */.Z, {
                                                    align: "center",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(LeaderboardUser, {
                                                            theme: theme,
                                                            user: scoreboardEntry
                                                        }),
                                                        scoreboardEntry.twitterUsername && /*#__PURE__*/ (0,jsx_runtime.jsx)(TwitterButton, {
                                                            username: scoreboardEntry.twitterUsername
                                                        })
                                                    ]
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Cell */.ZP.Cell, {
                                                css: {
                                                    textAlign: "center"
                                                },
                                                children: scoreboardEntry.numTipsSent
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(table/* default.Cell */.ZP.Cell, {
                                                css: {
                                                    textAlign: "center"
                                                },
                                                children: [
                                                    (scoreboardEntry.successRate * 100).toFixed(0),
                                                    "%"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Cell */.ZP.Cell, {
                                                css: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.ZP, {
                                                    variant: "flat",
                                                    color: "primary",
                                                    children: (0,utils/* formatAmount */.dN)(scoreboardEntry.satsSent)
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(table/* default.Cell */.ZP.Cell, {
                                                css: {
                                                    textAlign: "center"
                                                },
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(badge/* default */.ZP, {
                                                    variant: "flat",
                                                    color: "secondary",
                                                    children: (0,utils/* formatAmount */.dN)(scoreboardEntry.achievementTypes.length)
                                                })
                                            })
                                        ]
                                    }, i);
                                })
                            })
                        ]
                    })
                })
            })
        ]
    });
}
function LeaderboardUser(param) {
    var user = param.user, theme = param.theme;
    var _name;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(NextLink/* NextLink */.p, {
        href: "".concat(PageRoutes/* PageRoutes.users */.d.users, "/").concat(user.userId),
        passHref: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
            style: {
                display: "flex",
                position: "relative",
                overflow: "visible"
            },
            children: [
                theme && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    style: {
                        position: "absolute",
                        top: -21,
                        left: 1,
                        zIndex: 10000
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(NextImage/* NextImage */.o, {
                        src: "/leaderboards/".concat(theme.toLowerCase(), "/hat.png"),
                        width: 60,
                        height: 60
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(esm_user/* default */.ZP, {
                    name: (_name = user.name) !== null && _name !== void 0 ? _name : constants/* DEFAULT_NAME */.j2,
                    src: (0,utils/* getAvatarUrl */.E$)(user.avatarURL, user.fallbackAvatarId)
                })
            ]
        })
    });
}


/***/ }),

/***/ 93871:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ LeaderboardsGrid; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(28723);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(64040);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(86979);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(27690);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(22553);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(8773);
/* harmony import */ var components_NextLink__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45201);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(66761);
/* harmony import */ var hooks_useUserRoles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46579);
/* harmony import */ var lib_PageRoutes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77137);
/* harmony import */ var lib_swr__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3718);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33299);
/* harmony import */ var next_auth_react__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_auth_react__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var pages_leaderboards_id___WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(4091);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(8100);










function LeaderboardsGrid(param) {
    var showAll = param.showAll, featured = param.featured, userId = param.userId;
    var ref = (0,swr__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)("/api/leaderboards".concat(userId ? "?userId=".concat(userId) : ""), lib_swr__WEBPACK_IMPORTED_MODULE_7__/* .defaultFetcher */ .V), leaderboards = ref.data;
    var ref1 = (0,hooks_useUserRoles__WEBPACK_IMPORTED_MODULE_2__/* .useUserRoles */ .s)(), userRoles = ref1.data;
    var ref2 = (0,next_auth_react__WEBPACK_IMPORTED_MODULE_4__.useSession)(), session = ref2.data;
    var _theme, _theme1, _theme2;
    return (leaderboards === null || leaderboards === void 0 ? void 0 : leaderboards.length) || (userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(function(role) {
        return role.roleType === "SUPERADMIN";
    })) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                align: "center",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                        b: true,
                        children: userId ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: "\uD83D\uDC51 Your Leaderboards"
                        }) : featured ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: "⭐ Featured Leaderboards"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                            children: "✨ All Leaderboards"
                        })
                    }),
                    !showAll ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                x: 0.5
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_NextLink__WEBPACK_IMPORTED_MODULE_1__/* .NextLink */ .p, {
                                href: "".concat(lib_PageRoutes__WEBPACK_IMPORTED_MODULE_3__/* .PageRoutes.leaderboards */ .d.leaderboards).concat(userId ? "?userId=".concat(userId) : ""),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                        size: "sm",
                                        flat: true,
                                        auto: true,
                                        children: "See All"
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                x: 0.5
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_NextLink__WEBPACK_IMPORTED_MODULE_1__/* .NextLink */ .p, {
                                href: lib_PageRoutes__WEBPACK_IMPORTED_MODULE_3__/* .PageRoutes.leaderboard */ .d.leaderboard,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                        size: "sm",
                                        flat: true,
                                        auto: true,
                                        children: "Global Leaderboard"
                                    })
                                })
                            })
                        ]
                    }),
                    session && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                x: 0.5
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_NextLink__WEBPACK_IMPORTED_MODULE_1__/* .NextLink */ .p, {
                                href: lib_PageRoutes__WEBPACK_IMPORTED_MODULE_3__/* .PageRoutes.newLeaderboard */ .d.newLeaderboard,
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP, {
                                        size: "sm",
                                        flat: true,
                                        auto: true,
                                        color: "primary",
                                        children: "Create Leaderboard"
                                    })
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                y: 0.5
            }),
            leaderboards && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"].Container */ .ZP.Container, {
                gap: 1,
                children: leaderboards.slice(0, featured ? 3 : undefined).map(function(leaderboard) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_NextLink__WEBPACK_IMPORTED_MODULE_1__/* .NextLink */ .p, {
                        href: "".concat(lib_PageRoutes__WEBPACK_IMPORTED_MODULE_3__/* .PageRoutes.leaderboards */ .d.leaderboards, "/").concat(leaderboard.id),
                        passHref: true,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .ZP, {
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP, {
                                    css: {
                                        minWidth: "min(400px, 80vw)",
                                        dropShadow: "$sm"
                                    },
                                    isHoverable: true,
                                    isPressable: true,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_leaderboards_id___WEBPACK_IMPORTED_MODULE_5__.LeaderboardBackground, {
                                            theme: (_theme = leaderboard.theme) !== null && _theme !== void 0 ? _theme : undefined
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_leaderboards_id___WEBPACK_IMPORTED_MODULE_5__.LeaderboardBackgroundTop, {
                                            theme: (_theme1 = leaderboard.theme) !== null && _theme1 !== void 0 ? _theme1 : undefined,
                                            variant: "card"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(pages_leaderboards_id___WEBPACK_IMPORTED_MODULE_5__.LeaderboardBackgroundBottom, {
                                            theme: (_theme2 = leaderboard.theme) !== null && _theme2 !== void 0 ? _theme2 : undefined,
                                            variant: "card"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_13__/* ["default"].Body */ .ZP.Body, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                        b: true,
                                                        children: leaderboard.title
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    justify: "space-between",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            size: "small",
                                                            color: "$gray700",
                                                            children: [
                                                                (0,date_fns__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(new Date(leaderboard.start), "d MMMM yyyy"),
                                                                " ",
                                                                "-",
                                                                " ",
                                                                leaderboard.end ? (0,date_fns__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)(new Date(leaderboard.end), "d MMMM yyyy") : "∞"
                                                            ]
                                                        }),
                                                        leaderboard.end && new Date(leaderboard.end).getTime() < Date.now() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                                                            size: "small",
                                                            color: "$gray700",
                                                            children: "Ended"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    }, leaderboard.id);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {})
        ]
    }) : null;
}


/***/ }),

/***/ 47855:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useLeaderboardContents; }
/* harmony export */ });
/* harmony import */ var lib_ApiRoutes__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(54591);
/* harmony import */ var lib_constants__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59953);
/* harmony import */ var lib_swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3718);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8100);




var pollLeaderboardConfig = {
    refreshInterval: 15000
};
function useLeaderboardContents(leaderboardId) {
    return (0,swr__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)("".concat(lib_ApiRoutes__WEBPACK_IMPORTED_MODULE_0__/* .ApiRoutes.leaderboards */ .M.leaderboards, "/").concat(leaderboardId !== null && leaderboardId !== void 0 ? leaderboardId : lib_constants__WEBPACK_IMPORTED_MODULE_1__/* .DEFAULT_LEADERBOARD_ID */ ._D, "/contents"), lib_swr__WEBPACK_IMPORTED_MODULE_3__/* .defaultFetcher */ .V, pollLeaderboardConfig);
}


/***/ }),

/***/ 15722:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ usePublicUser; }
/* harmony export */ });
/* harmony import */ var lib_swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3718);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8100);


function usePublicUser(userId) {
    var forceAnonymous = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return (0,swr__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP)(userId ? "/api/users/".concat(userId, "?publicProfile=true&forceAnonymous=").concat(forceAnonymous) : undefined, lib_swr__WEBPACK_IMPORTED_MODULE_1__/* .defaultFetcher */ .V);
}


/***/ }),

/***/ 54591:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ ApiRoutes; }
/* harmony export */ });
var ApiRoutes;
(function(ApiRoutes) {
    ApiRoutes["leaderboards"] = "/api/leaderboards";
    ApiRoutes["tipGroups"] = "/api/tipGroups";
    ApiRoutes["admin"] = "/api/admin";
    ApiRoutes["adminTips"] = "/api/admin/tips";
    ApiRoutes["adminUsers"] = "/api/admin/users";
    ApiRoutes["tipperTips"] = "/api/tipper/tips";
    ApiRoutes["tippeeTips"] = "/api/tippee/tips";
})(ApiRoutes || (ApiRoutes = {}));


/***/ }),

/***/ 4091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LeaderboardBackground": function() { return /* binding */ LeaderboardBackground; },
/* harmony export */   "LeaderboardBackgroundBottom": function() { return /* binding */ LeaderboardBackgroundBottom; },
/* harmony export */   "LeaderboardBackgroundTop": function() { return /* binding */ LeaderboardBackgroundTop; },
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28723);
/* harmony import */ var _nextui_org_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(97501);
/* harmony import */ var components_LeaderboardTable__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42281);
/* harmony import */ var hooks_useUserRoles__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46579);
/* harmony import */ var lib_PageRoutes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77137);
/* harmony import */ var lib_swr__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(3718);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8100);








var CustomLeaderboardPage = function() {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    var id = router.query.id;
    var leaderboardId = id;
    var ref = (0,hooks_useUserRoles__WEBPACK_IMPORTED_MODULE_2__/* .useUserRoles */ .s)(), userRoles = ref.data;
    var ref1 = (0,swr__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)("/api/".concat(lib_PageRoutes__WEBPACK_IMPORTED_MODULE_3__/* .PageRoutes.leaderboards */ .d.leaderboards, "/").concat(id), lib_swr__WEBPACK_IMPORTED_MODULE_6__/* .defaultFetcher */ .V), leaderboard = ref1.data;
    if (!leaderboard) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    y: 4
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_nextui_org_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .ZP, {
                    color: "currentColor",
                    size: "lg",
                    children: "Loading..."
                })
            ]
        });
    }
    var _theme, _theme1, _theme2;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_LeaderboardTable__WEBPACK_IMPORTED_MODULE_1__/* .LeaderboardTable */ .H, {
                canEdit: userRoles === null || userRoles === void 0 ? void 0 : userRoles.some(function(role) {
                    return role.roleType === "SUPERADMIN";
                }),
                leaderboardId: leaderboardId,
                title: leaderboard.title,
                creatorId: leaderboard.creatorId,
                startDate: new Date(leaderboard.start),
                endDate: leaderboard.end ? new Date(leaderboard.end) : undefined,
                isGlobal: leaderboard.global,
                theme: leaderboard.theme || undefined
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeaderboardBackground, {
                theme: (_theme = leaderboard.theme) !== null && _theme !== void 0 ? _theme : undefined
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeaderboardBackgroundTop, {
                theme: (_theme1 = leaderboard.theme) !== null && _theme1 !== void 0 ? _theme1 : undefined
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(LeaderboardBackgroundBottom, {
                theme: (_theme2 = leaderboard.theme) !== null && _theme2 !== void 0 ? _theme2 : undefined
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (CustomLeaderboardPage);
function LeaderboardBackground(param) {
    var theme = param.theme;
    if (!theme) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            position: "absolute",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            background: "url(/leaderboards/".concat(theme.toLowerCase(), "/background.png)"),
            backgroundSize: "25%",
            backgroundRepeat: "repeat",
            opacity: 0.05,
            zIndex: -1
        }
    });
}
function LeaderboardBackgroundTop(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "page" : _variant, theme = param.theme;
    if (!theme) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            position: "absolute",
            top: variant === "card" ? "-10%" : "76px",
            left: 0,
            width: variant === "card" ? "200%" : "100vw",
            height: variant === "card" ? "300%" : "min(50vw, calc(100vh - 76px))",
            background: "url(/leaderboards/".concat(theme.toLowerCase(), "/bg-top.png)"),
            backgroundSize: "contain",
            backgroundPositionX: "140%",
            opacity: 0.5,
            zIndex: -1
        }
    });
}
function LeaderboardBackgroundBottom(param) {
    var _variant = param.variant, variant = _variant === void 0 ? "page" : _variant, theme = param.theme;
    if (!theme) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        style: {
            position: "absolute",
            bottom: 0,
            left: 0,
            width: variant === "card" ? "100%" : "100vw",
            height: variant === "card" ? "100%" : "50vw",
            background: "url(/leaderboards/".concat(theme.toLowerCase(), "/bg-bottom.png)"),
            backgroundSize: "contain",
            opacity: 0.5,
            zIndex: -1
        }
    });
}


/***/ })

}]);